/* eslint-disable @typescript-eslint/no-explicit-any */
import JanusMessage from './message'

class JanusError extends Error {
  private readonly janusMessage: JanusMessage
  private readonly code: any

  constructor(message: JanusMessage) {
    super()

    this.name = this.constructor.name
    this.janusMessage = message

    const error = message.getError()
    this.message = error.reason
    this.code = error.code
  }

  getJanusMessage(): JanusMessage {
    return this.janusMessage
  }

  getCode(): any {
    return this.code
  }
}

export default JanusError
